/// groups
export const GROUP_QUERY_KEY = "groups-query";
export const GROUP_ADMIN_QUERY_KEY = "groups-admin-query";
export const GROUP_EVENT_QUERY_KEY = "groups-event-query";
export const NEW_GROUP_MUTATION = "new-group-mutation";
export const EDIT_GROUP_MUTATION = "edit-group-mutation";
export const REMOVE_GROUP_MUTATION = "remove-group-mutation";
export const ALL_PAYMENTS_QUERY_KEY = "all-payments-query";

/// events
export const NEW_PARTICIPANT_QUERY = "new-participant-query";
export const UPDATE_PARTICIPANT_QUERY = "update-participant-query";
export const REMOVE_PARTICIPANT_QUERY = "remove-participant-query";
export const GROUP_PUBLIC_EVENT_QUERY_KEY = "groups-public-event-query";
export const GROUP_EVENTS_QUERY_KEY = "groups-events-query";
export const GROUP_ALL_EVENTS_QUERY_KEY = "groups-all-events-query";
export const GROUP_GUEST_QUERY_KEY = "groups-guest-query";
export const UPLOAD_PAYMENT_MUTATION = "upload-payment-mutation";
export const UPDATE_PAYMENT_MUTATION = "update-payment-mutation";
export const PARTICIPANT_LOG_QUERY = "participant-log-query";
export const EVENT_STATISTICS_QUERY_KEY = "event-statistics-query";
export const EVENT_ANALYZE_RECEIPT_MUTATION = "event-analyze-receipt-mutation";
export const ACTIVE_EVENTS_QUERY_KEY = "active-events-query";
export const REMOVE_PARTICIPANT_MUTATION = "remove-participant-mutation";
export const GROUP_NEXT_EVENTS_QUERY_KEY = "groups-next-events-query";
export const EVENT_MOVE_PARTICIPANT_MUTATION = "event-move-participant-mutation";
export const MOVE_PARTICIPANTS_TO_EVENT_MUTATION = "move-participants-to-event-mutation";
export const DECLINE_NON_ATTENDING_MUTATION = "decline-non-attending-mutation";
export const EVENT_ROOMS_AUTO_ASSIGN_QUERY_KEY = "event-rooms-auto-assign-query";
export const EVENT_SERVER_ROOMS_RESERVATION_QUERY_KEY = "event-server-rooms-reservation-query";
export const GROUP_EVENT_MUTATION = "group-event-mutation";
export const EVENT_UPDATE_ROOM_MUTATION = "event-update-room-mutation";
export const EVENT_UPDATE_PARTICIPANT_ROOM_MUTATION = "event-update-participant-room-mutation";
export const EVENT_UPDATE_WORKSHOP_MUTATION = "event-update-workshop-mutation";
export const EVENT_REMOVE_WORKSHOP_MUTATION = "event-remove-workshop-mutation";
export const EVENT_ADD_WORKSHOP_MUTATION = "event-add-workshop-mutation";
export const EVENT_UPDATE_PARTICIPANT_WORKSHOP_MUTATION = "event-update-participant-workshop-mutation";
export const EVENT_UPDATE_PARTICIPANT_STATUS_MUTATION = "event-update-participant-status-mutation";
export const EVENT_UPDATE_PARTICIPANT_PAYMENT_CONFIG_MUTATION = "event-update-participant-payment-config-mutation";
export const EVENT_UPDATE_PARTICIPANT_CAR_INFO_MUTATION = "event-update-participant-car-info-mutation";
export const EVENT_UPDATE_PARTICIPANT_CALLS_MUTATION = "event-update-participant-calls-mutation";
export const EVENT_UPDATE_COMISSION_MUTATION = "event-update-comission-mutation";
export const EVENT_UPDATE_WORKSHOPS_BY_AGE_MUTATION = "event-update-workshops-by-age-mutation";
export const EVENT_UPDATE_WORKSHOPS_RANDOMLY_MUTATION = "event-update-workshops-random-mutation";
export const EVENT_UPDATE_SERVERS_FROM_COMMITMENT_MUTATION = "event-update-servers-from-commitment-mutation";

// invitations
export const INVITATION_QUERY_KEY = "invitations-query";
export const INVITATION_UPDATE_MUTATION = "invitation-update-mutation";
export const INVITATION_REMOVE_MUTATION = "invitation-remove-mutation";
export const INVITATION_PUBLIC_QUERY_KEY = "invitation-public-query";
export const INVITATION_GUEST_QUERY_KEY = "invitation-guest-query";
export const INVITATION_GUEST_UPDATE_MUTATION = "invitation-guest-update-mutation";
export const INVITATION_GUEST_REMOVE_MUTATION = "invitation-guest-remove-mutation";
export const INVITATION_GUEST_PUBLIC_QUERY_KEY = "invitation-guest-public-query";
export const INVITATION_UPLOAD_IMAGE_MUTATION = "invitation-upload-image-mutation";
export const INVITATION_CONFIRMATION_MUTATION = "invitation-confirmation-mutation";

// services
export const SERVERS_QUERY_KEY = "servers-query";
export const SERVERS_UPDATE_MUTATION = "servers-update-mutation";
export const SERVERS_REMOVE_MUTATION = "servers-remove-mutation";
export const MEETING_QUERY_KEY = "meeting-query";
export const MEETING_UPDATE_MUTATION = "meeting-update-mutation";
export const MEETING_REMOVE_MUTATION = "meeting-remove-mutation";
export const SERVICES_QUERY_KEY = "services-query";
export const SERVICES_UPDATE_MUTATION = "services-update-mutation";
export const SERVICES_REMOVE_MUTATION = "services-remove-mutation";
export const UPDATE_SINGLE_SERVICE_MUTATION = "update-single-service-mutation";
export const MEETING_DATA_QUERY_KEY = "meeting-data-query";
export const GROUP_SERVICES_QUERY_KEY = "group-services-query";
export const GROUP_SERVICE_UPDATE_MUTATION = "group-service-update-mutation";
export const GROUP_SERVICE_REMOVE_MUTATION = "group-service-remove-mutation";
export const GROUP_SERVICE_TYPES_QUERY_KEY = "group-service-types-query";
export const GROUP_SERVICE_TYPE_UPDATE_MUTATION = "group-service-type-update-mutation";
export const GROUP_SERVICE_TYPE_REMOVE_MUTATION = "group-service-type-remove-mutation";
export const MEETING_ATTENDANCE_RECORDS_QUERY_KEY = "meeting-attendance-records-query";
export const MEETING_ATTENDANCE_UPDATE_MUTATION = "meeting-attendance-update-mutation";
export const PUBLIC_MEETING_ATTENDANCE_INFO_QUERY_KEY = "public-meeting-attendance-info-query";
export const PUBLIC_MEETING_ATTENDANCE_MARK_MUTATION = "public-meeting-attendance-mark-mutation";
export const SERVICES_DASHBOARD_QUERY_KEY = "services-dashboard-query";

export const SERVERS_ATTENDANCE_DATA_QUERY_KEY = "servers-attendance-data-query";
export const CREATE_SERVICE_SERVER_MUTATION = "create-service-server-mutation";

/// guests
export const GROUP_PUBLIC_GUEST_QUERY_KEY = "groups-public-guest";

// commitment
export const COMMITMENT_LIST_QUERY_KEY = "commitment-list-query";
export const CURRENT_COMMITMENT_QUERY_KEY = "current-commitment-query";
export const COMMITMENT_PUBLIC_QUERY_KEY = "commitment-public-query";
export const COMMITMENT_PUBLIC_GROUP_QUERY_KEY = "commitment-public-group-query";
export const COMMITMENT_PUBLIC_REGISTRATION_MUTATION = "commitment-public-registration-mutation";
export const COMMITMENT_PUBLIC_GUEST_REGISTRATION_MUTATION = "commitment-public-guest-registration-mutation";
export const COMMITMENT_PUBLIC_VERIFY_SERVER_BY_PHONE_QUERY_KEY = "commitment-public-verify-server-by-phone-query";
export const COMMITMENT_SERVERS_QUERY_KEY = "commitment-servers-query";
export const CURRENT_COMMITMENT_SERVERS_QUERY_KEY = "current-commitment-servers-query";
export const COMMITMENT_GUESTS_QUERY_KEY = "commitment-guests-query";
export const COMMITMENT_SERVERS_BY_GROUP_PUBLIC_QUERY_KEY = "commitment-servers-by-group-public-query";
export const COMMITMENT_DASHBOARD_DATA_QUERY_KEY = "commitment-dashboard-data-query";
export const COMMITMENT_SERVER_UPDATE_MUTATION = "commitment-server-update-mutation";
export const COMMITMENT_SERVER_ATTENDANCE_MUTATION = "commitment-server-attendance-mutation";
export const COMMITMENT_SERVER_REMOVE_MUTATION = "commitment-server-remove-mutation";
export const COMMITMENT_SERVER_PAYMENT_UPDATE_MUTATION = "commitment-server-payment-update-mutation";
export const COMMITMENT_SERVER_UPLOAD_PROFILE_PICTURE_MUTATION = "commitment-server-upload-profile-picture-mutation";

// prayerRequest
export const PRAYER_REQUEST_QUERY_KEY = "prayer-request-query";
export const PRAYER_REQUEST_DETAILS_QUERY_KEY = "prayer-request-details-query";
export const PRAYER_REQUEST_PUBLIC_QUERY_KEY = "prayer-request-public-query";
export const PRAYER_REQUEST_MUTATION = "prayer-request-mutation";

// preaching
export const PREACHING_SERMONS_QUERY_KEY = "preaching-sermons-query";
export const PREACHING_SERMON_UPDATE_MUTATION = "preaching-sermon-update-mutation";
export const PREACHING_SERMON_REMOVE_MUTATION = "preaching-sermon-remove-mutation";
export const PREACHING_RESOURCES_QUERY_KEY = "preaching-resources-query";
export const PREACHING_RESOURCE_UPDATE_MUTATION = "preaching-resource-update-mutation";
export const PREACHING_RESOURCE_REMOVE_MUTATION = "preaching-resource-remove-mutation";
export const PREACHING_EVENTS_QUERY_KEY = "preaching-events-query";
export const PREACHING_EVENT_UPDATE_MUTATION = "preaching-event-update-mutation";
export const PREACHING_EVENT_REMOVE_MUTATION = "preaching-event-remove-mutation";
export const PREACHING_MEETINGS_QUERY_KEY = "preaching-meetings-query";
export const PREACHING_MEETING_UPDATE_MUTATION = "preaching-meeting-update-mutation";
export const PREACHING_GROUP_BLOCKED_DATES_UPDATE_MUTATION = "preaching-group-blocked-dates-update-mutation";
export const PREACHING_ATTENDANCE_QUERY_KEY = "preaching-attendance-query";
export const PREACHING_ATTENDANCE_UPDATE_MUTATION = "preaching-attendance-update-mutation";
export const PREACHING_PREFERENCE_QUERY_KEY = "preaching-preference-query";
export const PREACHING_PREFERENCES_LIST_QUERY_KEY = "preaching-preferences-list-query";
export const PREACHING_PREFERENCE_UPDATE_MUTATION = "preaching-preference-update-mutation";
export const PREACHING_GENERATE_ASSIGNMENTS_MUTATION = "preaching-generate-assignments-mutation";
export const PREACHING_NOTIFY_ALL_MUTATION = "preaching-notify-all-mutation";
export const PREACHING_NOTIFY_PREACHER_MUTATION = "preaching-notify-preacher-mutation";
export const PREACHING_PREACHER_CONFIG_UPDATE_MUTATION = "preaching-preacher-config-update-mutation";
export const PREACHING_DASHBOARD_STATS_QUERY_KEY = "preaching-dashboard-stats-query";

// home settings
export const HOME_SETTINGS_QUERY_KEY = "home-settings-query";
export const HOME_SETTINGS_UPDATE_MUTATION = "home-settings-update-mutation";

// ministries
export const MINISTRIES_LIST_QUERY_KEY = "ministries-list-query";
export const MINISTRY_UPDATE_MUTATION = "ministry-update-mutation";
export const MINISTRY_CREATE_MUTATION = "ministry-create-mutation";
export const MINISTRY_REMOVE_MUTATION = "ministry-remove-mutation";
